import type { FC } from 'react';

import { CheckCircleFilled } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { Button, Modal } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

import styles from '../styles.module.less';

type Props = {
  open: boolean;
  hadMovedMembers: boolean;
  onBackHome: () => void;
  onPlanAnother: () => void;
};

export const PlanMonthlyJourneySuccessModal: FC<Props> = ({
  open,
  hadMovedMembers,
  onBackHome,
  onPlanAnother,
}) => {
  const intl = useIntl();

  return (
    <Modal open={open} closable={false} destroyOnClose footer={null} width={480} centered>
      <div className={styles.successIcon}>
        <CheckCircleFilled />
      </div>
      <div className={styles.successTitle}>
        {intl.formatMessage({
          id: hadMovedMembers
            ? 'workJourney.management.plan.success.pendingTitle'
            : 'workJourney.management.plan.success.savedTitle',
        })}
      </div>
      <div className={styles.successBody}>
        {intl.formatMessage({
          id: hadMovedMembers
            ? 'workJourney.management.plan.success.pendingBody'
            : 'workJourney.management.plan.success.savedBody',
        })}
      </div>
      <div className={styles.successActions}>
        <Button type="primary" onClick={onBackHome} block>
          <IntlMessages id="workJourney.management.plan.success.backHome" />
        </Button>
        <Button onClick={onPlanAnother} block>
          <IntlMessages id="workJourney.management.plan.success.planAnother" />
        </Button>
      </div>
    </Modal>
  );
};
